// import WidgetComponent from './components/widget';

// export default WidgetComponent;

import Loader from './moduls/loader';

Loader.start();



// WEBPACK FOOTER //
// ./index.js